import { useState, type FormEvent } from 'react';
import { ApiError } from '../api/client';
import { mfaStepUp } from '../api/auth';

interface Props {
  title?: string;
  onVerified: () => void | Promise<void>;
  onClose: () => void;
}

// Čerstvé ověření druhým faktorem před citlivou akcí (reset hesla/2FA jinému
// uživateli). Server vrací 403 MFA_STEP_UP_REQUIRED, dokud kód neprojde.
export function MfaStepUpModal({ title = 'Potvrďte akci', onVerified, onClose }: Props) {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    e.stopPropagation();
    setError(null);
    setBusy(true);
    try {
      await mfaStepUp(code.trim());
      await onVerified();
    } catch (err) {
      setError(err instanceof ApiError && err.code === 'MFA_INVALID_CODE' ? 'Kód není platný.' : 'Ověření selhalo.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true" style={{ background: 'rgba(0,0,0,.45)' }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <form className="modal-content" onSubmit={onSubmit}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Zavřít" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p className="small text-muted mb-2">Zadejte aktuální kód z ověřovací aplikace.</p>
            <input
              className="form-control"
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              maxLength={11}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              disabled={busy}
            />
            {error && <div className="alert alert-danger mt-2 mb-0 py-2">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={busy}>Zrušit</button>
            <button type="submit" className="btn btn-primary" disabled={busy || !code.trim()}>{busy ? 'Ověřuji…' : 'Ověřit'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
